import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import OutgoingCorrespondencesHandoverContent from '../content/outgoingCorrespondencesHandoverContent';
import addHandoverWrapper from '../handoverWrapper';

class OutgoingCorrespondencesHandover extends React.Component {
	static getTitle() {
		return 'Outgoing Correspondence';
	}

	render() {
		const report = this.props.report.data[0];
		
		return (
			<OutgoingCorrespondencesHandoverContent report={report} />
		);
	}
}

OutgoingCorrespondencesHandover.propTypes = {
	context: PropTypes.object.isRequired,
	route: PropTypes.object.isRequired,
	report: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	context: state.context
});

export default connect(
	mapStateToProps
)(addHandoverWrapper(
	OutgoingCorrespondencesHandover, {
		title: 'Outgoing Correspondence',
		className: 'outgoing-correspondences-handover'
	})
);
